import { createContext, useState } from "react";

export const GlobalStatesContext = createContext({
    searchTerm: null,
    setSearchTerm: () => {}
});

export const GlobalStatesProvider = ({children}) => {
    const [searchTerm, setSearchTerm] = useState('');

    const value = {searchTerm, setSearchTerm}

    return <GlobalStatesContext.Provider value={value}>{ children }</GlobalStatesContext.Provider>
}